import type { SVGIconProps } from "@repo/icons";
import type { FunctionComponent, ReactNode } from "react/jsx-runtime";

export interface PaymentTermsOfServiceProps {
  Icon: FunctionComponent<SVGIconProps>;
  children: ReactNode;
  title: string;
  fillAsStroke?: boolean;
}

export const PaymentTermsOfServiceItem = ({
  Icon,
  title,
  children,
  fillAsStroke = false,
}: PaymentTermsOfServiceProps): JSX.Element => {
  const iconFillType = fillAsStroke ? "stroke-primary-500" : "fill-primary-500";

  return (
    <div className="flex flex-row flex items-center gap-4 w-full">
      <div className="w-16 aspect-square rounded-full bg-primary-100 flex items-center justify-center">
        <Icon className={iconFillType} size={32} />
      </div>
      <div className="overflow-hidden break-all w-full">
        <span className="text-md leading-6 text-neutral-500">
          <p className="text-neutral-600 font-medium break-normal">{title}</p>
          <p className="text-neutral-500 break-normal">{children}</p>
        </span>
      </div>
    </div>
  );
};
